import { Controller } from 'libraries/front-end-core/core/Router'
import Main from './Main'
import { NOT_FOUND } from 'constants/controllers'

export default new Controller({
  name: NOT_FOUND,
  route: '(/:flavour)*path',
  controller (Router, evt, render) {
    render(
      { Main },
      {},
      evt.params
    )

    return evt.url
  }
})
